import { Component, computed, input, output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Temporal } from 'temporal-polyfill'
import { AppLink } from './home-page.service'
import { fromNow } from '../shared/utilities/temporal'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-link',
  imports: [
    RouterLink,
    MatIcon,
  ],
  template: `
    <a class='link-secondary' [routerLink]="link().path">{{ link().title }}</a>
    @if (timestampText()) {
      <span class='timestamp ms-2'>{{ timestampText() }}</span>
    }
    @if (favoriteIconVisible()) {
      <mat-icon
          [fontIcon]="fontIcon()"
          class='ms-1'
          [class.favorite]="link().favorite"
          [class.not-favorite]="!link().favorite"
          (click)="toggleFavorite.emit(link())"
      />
    }
  `,
  styles: `
    :host {
      display: block;
      margin-bottom: 5px;
      
      .timestamp {
        font-size: 90%;
        opacity: 0.7;
      }
      
      mat-icon {
        cursor: pointer;
        font-size: 18px;
        height: 20px;
        vertical-align: bottom;
        
        &.not-favorite {
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
        
        &.favorite {
          color: var(--bs-primary);
          &:hover {
            opacity: 0.5;
          }
        }
      }
    }
  `,
})
export class AppLinkComponent {
  readonly link = input.required<AppLink>()
  readonly now = input.required<Temporal.Instant>()

  readonly toggleFavorite = output<AppLink>()

  readonly favoriteIconVisible = computed((): boolean => typeof this.link().favorite === 'boolean')

  readonly fontIcon = computed(() => this.link().favorite ? 'star' : 'star_outline')

  readonly timestampText = computed((): string => {
    const { timestamp } = this.link()
    return timestamp ? fromNow(timestamp, { defaultMessageThresholdSeconds: 60, now: this.now() }) : ''
  })
}
